export default class InputEvent extends Event {
	/**
	 * The static BLURRED type is dispatched when the Input is focused and the user tabs out or click somewhere else on the screen.
	 *
	 * Example: addEventListener(InputEvent.BLURRED, (event: InputEvent) => {});
	 */
	public static BLURRED = 'InputEvent.blurred';
	/**
	 * The static CHANGED type is dispatched when the Input text is changed by the user by typing, clipping or pasting into the Input.
	 *
	 * Example: addEventListener(InputEvent.CHANGED, (event: InputEvent) => {});
	 */
	public static CHANGED = 'InputEvent.changed';
	/**
	 * The static ENTER type is diaptched when the Input is focused and the Enter key is pressed and released.
	 *
	 * Example: addEventListener(InputEvent.ENTER, (event: InputEvent) => {});
	 */
	public static ENTER = 'InputEvent.enter';
	/**
	 * The static FOCUSED type is dispatched when the Input is focused with a Pointer click or being tabbed into.
	 *
	 * Example: addEventListener(InputEvent.FOCUSED, (event: InputEvent) => {});
	 */
	public static FOCUSED = 'InputEvent.focused';
	/** All event types will set the Input.text property to the current text content of the Input. */
	public text: string;
	/**
	 * The InputEvent will be dispatched everytime the user focuses, blurs og change the text content.
	 *
	 * @param type InputEvent.blurred | InputEvent.changed | InputEvent.focused
	 * @param text The current text content of the Input
	 */
	public constructor(type: string, text: string) {
		assertIsValidType(type);
		assertIsString(text);
		super(type, { bubbles: true });
		this.text = text;
	}
}

function assertIsString(value: unknown): asserts value is string {
	if (typeof value === 'string') {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be of type string`);
}

function assertIsValidType(value: unknown): asserts value is string {
	if (value === InputEvent.BLURRED || value === InputEvent.CHANGED || value === InputEvent.ENTER || value === InputEvent.FOCUSED) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be InputEvent.BLURRED, InputEvent.CHANGED, InputEvent.ENTER or InputEvent.FOCUSED`);
}
